<div class="card">
  <div class="card-body">
    <h3 class="title mb-4">Alumni</h3>

    @if (!AlumniList.length) {
      <!-- coming soon -->
      <div class="d-flex align-items-center justify-content-between">
        <svg-icon class="svg-w-100 mx-auto mb-4" src="/assets/Icons/new/time.svg"
          style="width: 150px;"></svg-icon>
      </div>
      <div class="soon-title text-center text-muted ">Coming soon!</div>
      }@else{
        <ul class="list p-0 m-0">
          <li class="item d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center gap-2">
              <div class="image-avatar">
                <img [src]="profileImageUrl ? profileImageUrl : defaultAvatar" class="avatar avatar-xxxl">
              </div>
              <div class="info">
                <div class="fullname d-flex align-items-center gap-2">
                  Hue Longman
                  <span class="tag tag-orange">Senior Student</span>
                  <!-- tag-green , tag-blue , tag-red , tag-info , tag-light-primary ,tag-primary -->
                </div>
                <div class="text">
                  I’m hue. A person who wants to know eveything about countries cultures and get connected to everyone from
                  eveywhere...
                </div>
              </div>
            </div>
            <div>
              <button class="btn btn-light d-flex gap-2 align-items-center">
                <svg-icon src="/assets/Icons/new/chat-text.svg"></svg-icon>
                Start Converstion
              </button>
            </div>
          </li>

          <li class="item d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center gap-2">
              <div class="image-avatar">
                <img [src]="profileImageUrl ? profileImageUrl : defaultAvatar" class="avatar avatar-xxxl">
              </div>
              <div class="info">
                <div class="fullname d-flex align-items-center gap-2">
                  Hue Longman
                  <span class="tag tag-orange">Senior Student</span>
                </div>

                <div class="text">
                  I’m hue. A person who wants to know eveything about countries cultures and get connected to everyone from
                  eveywhere...
                </div>
              </div>
            </div>

            <div>
              <button class="btn btn-light d-flex gap-2 align-items-center">
                <svg-icon src="/assets/Icons/new/chat-text.svg"></svg-icon>
                Start Converstion
              </button>
            </div>
          </li>

          <li class="item d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center gap-2">
              <div class="image-avatar">
                <img [src]="profileImageUrl ? profileImageUrl : defaultAvatar" class="avatar avatar-xxxl">
              </div>
              <div class="info">
                <div class="fullname d-flex align-items-center gap-2">
                  Hue Longman
                  <span class="tag tag-orange">Senior Student</span>
                </div>

                <div class="text">
                  I’m hue. A person who wants to know eveything about countries cultures and get connected to everyone from
                  eveywhere...
                </div>
              </div>
            </div>

            <div>
              <button class="btn btn-light d-flex gap-2 align-items-center">
                <svg-icon src="/assets/Icons/new/chat-text.svg"></svg-icon>
                Start Converstion
              </button>
            </div>
          </li>
        </ul>

      }
  </div>
</div>